import { TeleportTarget, useXR } from '@react-three/xr';
import { PointerLockControls } from '@react-three/drei';

export default function XRControls() {
  const session = useXR((state) => state.session);

  return (
    <>
      {!session ? <PointerLockControls makeDefault /> : null}
      <TeleportTarget>
        <mesh position={[0, -1.05, 0]} rotation={[-Math.PI / 2, 0, 0]}>
          <circleGeometry args={[18, 64]} />
          <meshBasicMaterial color="#031423" transparent opacity={0.12} />
        </mesh>
      </TeleportTarget>
    </>
  );
}
